import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {empty} from '../../functions';
import {ModalService} from '../../shared/services/modal.service';
import {ModalAdminMatchtestCompetencyComponent} from './modal-admin-matchtest-competency/modal-admin-matchtest-competency.component';
import {catchError} from 'rxjs/operators';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {MatchService} from '../../shared/services/match.service';
import {AdminService} from '../../shared/services/admin.service';
import {ModalAdminMatchtestQuestionComponent} from './modal-admin-matchtest-question/modal-admin-matchtest-question.component';

@Component({
    selector: 'app-admin-matchtest',
    templateUrl: './admin-matchtest.component.html',
    styleUrls: ['./admin-matchtest.component.scss'],
    standalone: false
})
export class AdminMatchtestComponent implements OnInit {

  activeTab = 'competencies';

  public tableConfigCompetencies = {
    hasPagination: true,
    columns: [

      {
        header_name: 'Name',
        name: 'name',
        type: 'text'
      },
      {
        header_name: 'Description',
        name: 'description',
        type: 'text'
      },
      {
        header_name: 'Type',
        name: 'type',
        type: 'text'
      },
    ],
    endpoint: 'matchcompetency',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject()
  }

  public tableConfigQuestions = {
    hasPagination: true,
    columns: [


      {
        header_name: 'Competency',
        name: 'competency',
        subName: 'name',
        type: 'text'
      },
      {
        header_name: 'Question',
        name: 'question',
        type: 'text'
      },
      {
        header_name: 'Answer 1',
        name: 'answer1',
        type: 'text'
      },
      {
        header_name: 'Answer 2',
        name: 'answer2',
        type: 'text'
      },
      {
        header_name: 'Answer 3',
        name: 'answer3',
        type: 'text'
      },
      {
        header_name: 'Answer 4',
        name: 'answer4',
        type: 'text'
      },
      {
        header_name: 'Answer 5',
        name: 'answer5',
        type: 'text'
      },
    ],
    endpoint: 'matchquestion',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject()
  }

  /**
   * Constructor
   */
  constructor(private modal: ModalService, private alertService: AlertService, private adminService: AdminService, private matchService: MatchService) { }

  ngOnInit(): void {

  }

  /**
   * Add a new matchtest competency
   */
  addMatchtestCompentency() {

    const data = {
      entity: {
        name: '',
        type: '',
        description: ''
      }
    };

    const modalOptions = {
      size: 'xl'
    }

    this.modal.Modal(ModalAdminMatchtestCompetencyComponent, '', '', data, [], modalOptions).then(
      (result) => {

        if (result == true) {
          this.tableConfigCompetencies.reloadListener.next(true);
        }

      }
    ).catch()
  }

  /**
   * Update match competency
   *
   * @param $id
   */
  updateMatchCompetency($data:string) {
    const data = {
      entity: $data
    };

    const modalOptions = {
      size: 'xl'
    }

    this.modal.Modal(ModalAdminMatchtestCompetencyComponent, '', '', data, [], modalOptions).then(
      (result) => {

        if (result == true) {
          this.tableConfigCompetencies.reloadListener.next(true);
        }

      }
    ).catch()
  }

  /**
   * Delete match competency
   *
   * @param $id
   */
  deleteMatchCompetency($id:string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.matchService.apiDeleteMatchtestCompetency($id).pipe(catchError(this.adminService.handleError('apiDeleteMatchtestCompetency', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.tableConfigCompetencies.reloadListener.next(true);
          }

        });

      }
    }).catch( (error) => {

    });

  }

  // extra
  /**
   * Add a new matchtest competency
   */
  addMatchtestQuestion() {

    const data = {
      entity: {
        competencyId: '',
        question: '',
        answer1: '',
        answer2: '',
        answer3: '',
        answer4: '',
        answer5: '',
      }
    };

    const modalOptions = {
      size: 'xl'
    }

    this.modal.Modal(ModalAdminMatchtestQuestionComponent, '', '', data, [], modalOptions).then(
      (result) => {

        if (result == true) {
          this.tableConfigQuestions.reloadListener.next(true);
        }

      }
    ).catch( (error) => {

    });
  }

  /**
   * Update match competency
   *
   * @param $id
   */
  updateMatchQuestion($data:string) {
    const data = {
      entity: $data
    };

    const modalOptions = {
      size: 'xl'
    }

    this.modal.Modal(ModalAdminMatchtestQuestionComponent, '', '', data, [], modalOptions).then(
      (result) => {

        if (result == true) {
          this.tableConfigQuestions.reloadListener.next(true);
        }

      }
    ).catch( (error) => {

    });
  }

  /**
   * Delete match competency
   *
   * @param $id
   */
  deleteMatchQuestion($id:string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.matchService.apiDeleteMatchtestQuestion($id).pipe(catchError(this.adminService.handleError('apiDeleteMatchtestQuestion', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.tableConfigQuestions.reloadListener.next(true);
          }

        });

      }
    }).catch( (error) => {

    });

  }

  /**
   * Handle table buttons events
   *
   * @param $event
   * @param $entity
   */
  handleButtonEvent($event:any, $entity:string) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'edit':

          if ($entity == 'matchcompetency') {
            this.updateMatchCompetency($event['data']);
          }
          if ($entity == 'matchquestion') {
            this.updateMatchQuestion($event['data']);
          }
          break;

        case 'delete':
          if ($entity == 'matchcompetency') {
            this.deleteMatchCompetency($event['data']['id']);
          }
          if ($entity == 'matchquestion') {
            this.deleteMatchQuestion($event['data']['id']);
          }
          break;
      }
    }

  }

}
